export const isSignedAgreement = (agreement) =>
  Boolean(
    ["active", "suspended", "ended"].includes(agreement?.status) &&
      agreement?.supplierSignature?.trim() &&
      agreement?.supplierSignedAt &&
      Number.isFinite(new Date(agreement.supplierSignedAt).getTime())
  );
